var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"text-center",attrs:{"value":!!_vm.alertType,"type":_vm.alertType}},[_vm._v(" "+_vm._s(_vm.textAlert)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }